<script lang="ts">
  import { _ } from "svelte-i18n";
</script>

<div class="steps">
  <div class="step">
    <div class="step-check"><slot name="email-check" /></div>
    <div><slot name="email" /></div>
    <p>{$_("steps.step1")}</p>
  </div>

  <div class="step">
    <div class="step-check"><slot name="password-check" /></div>
    <div><slot name="password" /></div>
    <p>{$_("steps.step2")}</p>
  </div>

  <div class="step">
    <div class="step-check"><slot name="login-check" /></div>
    <div><slot name="login" /></div>
    <p>{$_("steps.step3")}</p>
  </div>
</div>

<style lang="less" scoped>
  .steps {
    display: flex;
    text-align: center;

    .step {
      display: flex;
      flex-flow: column;
      align-items: center;
      padding: 0 2.25rem;

      .step-check {
        margin-bottom: 2rem;
      }

      p {
        margin-top: 1rem;
        font-size: 18px;
        font-weight: 700;
        white-space: pre-line;
      }
    }
  }

  @media only screen and (max-width: 600px) {
    .steps {
      .step {
        padding: 0 1.125rem;

        .step-check {
          margin-bottom: 1rem;
        }

        p {
          margin-top: 0.5rem;
          font-size: 0.7rem;
        }
      }
    }
  }
</style>
